import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alarm-chart-wrapper widget" }
const _hoisted_2 = { class: "alarm-chart" }
const _hoisted_3 = { ref: "chart" }
const _hoisted_4 = { class: "h-100 w-100 center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slot_details_modal = _resolveComponent("slot-details-modal")!
  const _component_n_spin = _resolveComponent("n-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("canvas", _hoisted_3, null, 512 /* NEED_PATCH */),
      _createVNode(_component_slot_details_modal, { ref: "modal" }, null, 512 /* NEED_PATCH */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(_component_n_spin, { size: "large" })
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.loading]
    ])
  ]))
}